import { DividerProps } from '@msc-b2c/interfaces/types';

export const Divider = ({
  className,
  borderWidth,
  color,
  marginTop,
  marginLeft,
  marginRight,
  marginBottom,
}: DividerProps) => {
  return (
    <div
      className={className}
      style={{
        borderBottomStyle: 'solid',
        borderBottomColor: color ?? '#DCDEE2',
        borderBottomWidth: borderWidth ?? '1px',
        marginTop: marginTop ?? undefined,
        marginLeft: marginLeft ?? undefined,
        marginRight: marginRight ?? undefined,
        marginBottom: marginBottom ?? undefined,
      }}
    ></div>
  );
};
